module.exports = __webpack_public_path__ + "static/media/right.191cc08f.svg";